import React from 'react';
import { Environment } from 'common/components';
import { MEDIA_WIDTH_DESKTOP } from 'common/config';

type AllProps = React.PropsWithChildren<{}>;

export const Mobile = ({ children }: AllProps) => <Environment max={MEDIA_WIDTH_DESKTOP - 1}>{children}</Environment>;
